var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.activeOverlaySelector
        ? _c(
            "b-field",
            { staticStyle: { float: "left", "margin-right": "10px" } },
            [
              _c(
                "b-select",
                {
                  attrs: { icon: "earth" },
                  on: { input: _vm.overlayLayerChanged },
                  model: {
                    value: _vm.checkedOverlayLayer,
                    callback: function ($$v) {
                      _vm.checkedOverlayLayer = $$v
                    },
                    expression: "checkedOverlayLayer",
                  },
                },
                _vm._l(_vm.overlayLayersData, function (layer, okey) {
                  return _c("option", {
                    key: okey,
                    attrs: { label: layer.title },
                    domProps: { value: okey },
                  })
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-field",
        { staticStyle: { float: "left" } },
        [
          _c(
            "b-select",
            {
              attrs: {
                disabled: this.$store.getters["isComparisonModeActive"],
                icon: "checkerboard",
              },
              on: { input: _vm.baseLayerChanged },
              model: {
                value: _vm.checkedBaseLayer,
                callback: function ($$v) {
                  _vm.checkedBaseLayer = $$v
                },
                expression: "checkedBaseLayer",
              },
            },
            _vm._l(_vm.baseLayersData, function (group, gkey) {
              return _c(
                "optgroup",
                { key: gkey, attrs: { value: gkey, label: _vm.$t(gkey) } },
                _vm._l(group, function (layer, lkey) {
                  return _c("option", {
                    key: lkey,
                    attrs: { label: layer.title },
                    domProps: { value: lkey },
                  })
                }),
                0
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }